import React, { useEffect, useState } from "react";
import { Variables, variables } from '../Variables.js';
import { useNavigate } from "react-router-dom";

function AllPlayers() {

    const [players, setState] = useState([])
    const navigate = useNavigate()


    //Load All Values for All Players (GET)
    const fetchPlayerData = () => {
        fetch(variables.API_URL + 'Player/getAllNBAPlayers')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch all nba players');
                }
                return response.json()
            })
            .then(data => {
                setState(data)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching player data: ", error);
                navigate('/error');
            });
    }


    //Run GET on page load
    useEffect(() => {
        fetchPlayerData()
        
    }, [])


    return (
       
        <div className="work-request--information">
                <input id="playerName" name="playerName" list="players" type="text" spellCheck="false" />
                <datalist id="players">
                {players.map(data =>

                    <option data-value={data.playerId} data-value2={data.teamId} data-value3={data.teamAbrev} value={data.name}></option>

          
                
                )}
                </datalist>

                <input type="hidden" name="playerId" id="playerId" />
                <input type="hidden" name="playerTeamId" id="playerTeamId" />
                <input type="hidden" name="playerTeamAbrev" id="playerTeamAbrev" />
   
            </div>
        
    )   
   
};

export default AllPlayers;
